var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu-link-top p-b-30",attrs:{"href":"/"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.logoutTranslation))])}
var staticRenderFns = []

export { render, staticRenderFns }